import React, { useState } from "react";
import styled from "styled-components";
import { makeStyles } from "@material-ui/core/styles";
import CommentForm from "./forms/CommentForm";
import moment from "moment";
import { IconButton, Paper } from "@material-ui/core";
import MaterialTable from "material-table";

import useTable from "./useTable";
import Iconify from "./Iconify";
import CommentsUtils from "../utils/comments";
import { useSelector } from "react-redux";
import Popup from "./Popup";
import Api from "../lib/api";
import ConfirmDialog from "./ConfirmDialog";
import Notification from "./Notification";

const Wrapper = styled.div`
  padding: ${(props) => props.theme.spacing(1) / 4}px
    ${(props) => props.theme.spacing(4)}px;
  flex-direction: column;
  display: flex;
  height: 100%;
`;

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: "6px 16px",
    flexGrow: 1,
  },
  form: {
    justifySelf: "self-end",
  },
}));

function TicketMessages(props) {
  const classes = useStyles();
  const { comments, onSave, ticketclosed, onCommentDeleted } = props;
  const { authUser } = useSelector((state) => state.auth);
  const [confirmDialogLoading, setConfirmDialogLoading] = useState(false);
  const [commentForEdit, setCommentForEdit] = useState(null);
  const { TblContainer } = useTable();
  const [commentPopupOpened, setCommentPopupOpened] = useState(false);
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });

  const closeCommentPopup = () => {
    setCommentPopupOpened(false);
    setCommentForEdit(null);
  };

  const saveComment = async (data) => {
    await onSave(data, commentForEdit);

    closeCommentPopup();
  };

  const dataMaterialTable = comments.map((o) => ({ ...o }));
  const headCellsMaterial = [
    { field: "comment", title: "Message" },
    {
      field: "user_id",
      title: "Created By",
      render: (rowData) => {
        return rowData.user.data ? rowData.user.data.title : "";
      },
      customFilterAndSearch: (term, rowData) =>
        rowData.user.data.title.toLowerCase().indexOf(term.toLowerCase()) != -1,
    },
    {
      field: "created",
      title: "Created Date",
      render: (rowData) => {
        return new moment(rowData.created_at).format("YYYY-MM-DD");
      },
      customFilterAndSearch: (term, rowData) =>
        rowData.created_at.toLowerCase().indexOf(term.toLowerCase()) != -1,
    },
  ];

  const openConfirmDialog = (
    setConfirmDialogObj,
    onConfirmHandle,
    onConfirmParam,
    title,
    subtitle = null
  ) => {
    setConfirmDialogObj({
      isOpen: true,
      title: title,
      subTitle: subtitle ? subtitle : "You can't undo this operation",
      onConfirm: () => onConfirmHandle(onConfirmParam),
    });
  };

  const closeConfirmDialog = (setConfirmDialogObj, confirmDialogObj) => {
    setConfirmDialogObj({
      ...confirmDialogObj,
      isOpen: false,
    });
  };

  const deleteComment = async (id) => {
    try {
      setConfirmDialogLoading(true);
      await Api.deleteComment(id);
      if (typeof onCommentDeleted == "function") {
        onCommentDeleted(id);
      }
    } catch (e) {
      setNotify({
        isOpen: true,
        message: e?.data?.message || "Something went wrong!",
        type: "error",
      });
    } finally {
      setConfirmDialogLoading(false);
      closeConfirmDialog(setConfirmDialog, confirmDialog);
    }
  };

  const onClickOnDelete = (id) => {
    openConfirmDialog(
      setConfirmDialog,
      deleteComment,
      id,
      "Are you sure to delete the comment?"
    );
  };

  return (
    <Wrapper>
      <Paper elevation={1} className={classes.paper}>
        <TblContainer>
          <MaterialTable
            columns={headCellsMaterial}
            data={dataMaterialTable}
            options={{
              pageSize: 5,
              emptyRowsWhenPaging: false,
              actionsColumnIndex: -1,
            }}
            actions={[
              {
                action: (rowData) => {
                  return {
                    icon: () => (
                      <IconButton color="primary" aria-label="add">
                        <Iconify
                          icon={"ic:outline-edit"}
                          width={22}
                          height={22}
                        />
                      </IconButton>
                    ),
                    tooltip: "Edit",
                    disabled: ticketclosed,
                    hidden: !CommentsUtils.userCanEditComment(
                      authUser,
                      rowData
                    ),
                    onClick: (event) => {
                      setCommentPopupOpened(true);
                      setCommentForEdit(rowData);
                    },
                    position: "row",
                  };
                },
              },
              {
                action: (rowData) => {
                  return {
                    icon: () => (
                      <IconButton color="primary" aria-label="add">
                        <Iconify
                          style={{ color: "red" }}
                          icon={"mdi:trash"}
                          width={22}
                          height={22}
                        />
                      </IconButton>
                    ),
                    tooltip: "Delete",
                    hidden: !CommentsUtils.userCanDeleteComment(
                      authUser,
                      rowData
                    ),
                    onClick: (event) => {
                      onClickOnDelete(rowData.id);
                    },
                    position: "row",
                  };
                },
              },
            ]}
            title="Ticket Messages"
          />
        </TblContainer>
      </Paper>

      <CommentForm
        resetAfterSubmit={true}
        saveComment={saveComment}
        className={classes.form}
        ticketclosed={ticketclosed}
      />

      <Popup
        title={"Update comment"}
        openPopup={commentPopupOpened}
        onClose={closeCommentPopup}
        fullWidth
        maxWidth={"sm"}
      >
        <CommentForm
          commentForEdit={commentForEdit}
          saveComment={saveComment}
        />
      </Popup>

      <ConfirmDialog
        confirmDialog={confirmDialog}
        setConfirmDialog={setConfirmDialog}
        confirmLoading={confirmDialogLoading}
      />
      <Notification notify={notify} setNotify={setNotify} />
    </Wrapper>
  );
}

export default TicketMessages;
